import { useMutation } from "@tanstack/react-query";
import { QUERY_KEYS } from "../querykeys";
import { acceptInviteApi } from "./acceptInvite.api";

// service/auth/useAcceptInviteMutation.ts
export const useAcceptInviteMutation = () =>
  useMutation({
    mutationKey: [QUERY_KEYS.ACCEPT_INVITE],
    mutationFn: acceptInviteApi,
  });
